import script from "./Test1.vue?vue&type=script&lang=ts"
export * from "./Test1.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__